<style lang="less">
    .villageBox{
        width: 1440px;
        height: auto;
        margin: 0 auto;
        text-align: left;
        @333:#333;
        @666:#666;
        @4d4d4d:#4D4D4D;
        @999:#999;
        font-family:PingFang SC;
        .cursor{
            cursor: pointer;
        }
        .breadcrumb{
            width: 100%;
            height: 30px;
            font-size:15px;
            font-family:PingFang SC;
            font-weight:400;
            color: @666;
            margin-top: 25px;
            line-height: 30px;
        }
        .villageInfoBox{
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
            .infoLeft{
                width: 300px;
                height: auto;
                background-color: #fff;
                .infoLeft_top{
                    width: 100%;
                    height: 346px;
                    font-size: 15px;
                    background-color: #fff;
                    padding: 0 10px;
                    .contractTitle{
                        color: @666;
                        display: flex;
                        justify-content: space-between;
                        margin-top: 20px;
                        .wantContract{
                            cursor: pointer;
                            color: @4d4d4d;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }
                    }
                    .middle{
                        .contImg{
                            width: 126px;
                            height: 126px;
                            position: relative;
                            overflow: hidden;
                            border-radius: 50%;
                            margin: 28px auto 5px;
                            &::after{
                                content: '';
                                display: block;
                                position: absolute;
                                width: 120px;
                                height: 120px;
                                left: -3px;
                                top: -3px;
                                border-radius: 50%;
                                border: 6px solid #CECECE;
                            }
                            img{
                                width: 100%;
                                height: 100%;
                            }
                            .houseNum{
                                position: absolute;
                                left: 0;
                                bottom: 0;
                                width:100%;
                                height:32px;
                                background:rgba(57,57,57,1);
                                opacity:0.8;
                                text-align: center;
                                line-height: 32px;
                                color: #fff;
                                font-size: 16px;
                            }
                            
                        }
                        p{
                            text-align: center;
                            color: @333;
                            padding: 5px 0;
                            &:nth-of-type(1){
                                font-size: 18px;
                            }
                            &:nth-of-type(2){
                                font-size: 16px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            }
                        }
                    }
                    .contFoot{
                        display: flex;
                        justify-content: space-evenly;
                        margin-top: 20px;
                        div{
                            width:68px;
                            height:30px;
                            opacity:1;
                            border-radius:14px;
                            line-height: 30px;
                            text-align: center;
                            cursor: pointer;
                        }
                        .follow{
                            border: 1px solid #5147E7;
                            color: #5147E7;
                        }
                        .complaint{
                            border: 1px solid #666666;
                            color: @666;
                        }
                    }
                }
                .infoLeft_bottom{
                    background-color: #fff;
                    width: 100%;
                    height: 600px;
                    font-size: 15px;
                    .fan{
                        height: 48px;
                        line-height: 48px;
                        color: @333;
                        border-bottom: 1px solid rgba(235,235,235,1);
                        padding-left: 20px;
                    }
                    .fanList{
                        margin-top: 10px;
                        padding: 0 24px 0 20px;
                        .fanBox{
                            padding: 10px 0;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            text-align: center;
                            .fanImg{
                                width: 36px;
                                height: 36px;
                                overflow: hidden;
                                border-radius: 50%;
                                position: relative;
                                &::after{
                                content: '';
                                    display: block;
                                    position: absolute;
                                    width: 34px;
                                    height: 34px;
                                    left: -1px;
                                    top: -1px;
                                    border-radius: 50%;
                                    border: 2px solid #707070;
                                }
                                img{
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .fanName{
                                flex: 3;
                                color: @4d4d4d;
                                margin-left: 10px;
                                text-align: left;
                            }
                            .fanRole{
                                flex: 1;
                                width:60px;
                                height:24px;
                                background:rgba(239,239,239,1);
                                border-radius:5px;
                                font-size: 13px;
                                line-height: 24px;
                                
                                color: @999;
                            }
                        }
                        
                    }
                }
            }
            .infoRight{
                width: 1130px;
                box-shadow:0px 1px 6px rgba(153,152,155,0.16);
                border-radius:10px;
                background-color: #fff;
                padding: 25px 20px;
                .houseList{
                    display: flex;
                    justify-content: flex-start;
                    margin-bottom: 50px;
                    >div{
                        margin-left: 3%;
                    }
                    .layoutImg{
                        width: 222px;
                        height: auto;
                        border: 1px solid #C0C0C0;
                        border-radius: 5px;
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .entityImg{
                        width: 222px;
                        height: auto;
                        border-radius: 5px;
                        overflow: hidden;
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .houseInfo{
                        .houseInfo_title{
                            font-size: 23px;
                            color: @333;
                            width: 580px;
                            word-wrap: break-word;
                            span{
                                display: inline-block;
                                width:60px;
                                height:24px;
                                line-height: 24px;
                                background:rgba(240,238,255,1);
                                opacity:1;
                                border-radius:5px;
                                font-size:13px;
                                text-align: center;
                                color: #7F8BDF;
                                cursor: pointer;
                                margin-left: 16px;
                            }
                        }
                        .detailInfo{
                            margin-top: 10px;
                            p{
                                color: @666;
                                font-size: 16px;
                                display: flex;
                                align-items: center;
                                padding-top: 12px;
                                font-weight: 400;
                                .releaseTime{
                                    display: inline-block;
                                    margin-left: 20px;
                                }
                            }
                        }
                    }
                }
                
            }
        }
    }
</style>
<template>
    <div class="villageBox">
        <div class="breadcrumb">
            <span class="cursor" @click="goBack">包小区</span>&nbsp;<i class="el-icon-arrow-right"></i>&nbsp;<span>{{contractInfo.villageName}}</span>
        </div>
        <div class="villageInfoBox">
            <div class="infoLeft">
                <div class="infoLeft_top">
                    <div class="contractTitle">
                        <div>小区承包人</div>
                        <div class="wantContract" @click="toContract"><img src="../assets/icon_buy_n.png" alt="">&nbsp;我要包小区</div>
                    </div>
                    <div class="middle">
                        <div class="contImg">
                            <img :src="contractInfo.imgUrl" alt="">
                            <div class="houseNum">{{contractInfo.houseNum}}户</div>
                        </div>
                        <p>{{contractInfo.villageName}}</p>
                        <p><img src="../assets/address1.png" alt="">&nbsp;{{contractInfo.address}}</p>
                    </div>
                    <div class="contFoot">
                        <div class="follow" @click="toFollow"><i class="el-icon-plus"></i>关注</div>
                        <div class="complaint" @click="toComplaint">投诉</div>
                    </div>
                </div>
                <div class="infoLeft_bottom">
                    <div class="fan">粉丝<span>{{fan.num}}</span></div>
                    <div class="fanList">
                        <!-- 每个粉丝 -->
                        <div class="fanBox cursor" v-for="item in fan.fanList" @click="toSeeFan">
                            <div class="fanImg"><img :src="item.imgUrl" alt=""></div>
                            <div class="fanName">{{item.fanName}}</div>
                            <div class="fanRole">{{item.fanRole}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="infoRight">
                <div class="houseList" v-for="item in houseList">
                    <div class="layoutImg">
                        <img :src="item.layoutImg" alt="">
                    </div>
                    <div class="entityImg">
                        <img :src="item.entityImg" alt="">
                    </div>
                    <div class="houseInfo">
                        <div class="houseInfo_title">
                            {{item.title}}
                            <span @click="toLookHouse">随时看</span>
                        </div>
                        <div class="detailInfo">
                            <p><img src="../assets/house.png" alt="">&nbsp;&nbsp;<span>{{item.houseInfo}}</span></p>
                            <p><img src="../assets/address1.png" alt="">&nbsp;&nbsp;<span>{{item.address}}</span></p>
                            <p><img src="../assets/follow.png" alt="">&nbsp;&nbsp;<span>{{item.attentionNum}}人关注</span><span class="releaseTime">{{item.releaseTime}}发布</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
var imgUrl = require('../assets/ceshi.jpg')
var img1 = require('../assets/ceshi1.jpg')
var img2 = require('../assets/ceshi2.jpg')
var img3 = require('../assets/icon_buy_n.png')
export default {
    components:{

    },
    props:['nowId'],
    data(){
        return {
            contractInfo:{
                imgUrl:imgUrl,
                address:'成都市青羊区蜀汉路12号',
                villageName:'玉兰花园',
                houseNum:1500,
            },
            fan:{
                num:'880',
                fanList:[
                    {
                        imgUrl:imgUrl,
                        fanName:'百多分全屋定制',
                        fanRole:'柜柜工厂'
                    },
                    {
                        imgUrl:imgUrl,
                        fanName:'心逸品定制盐源店',
                        fanRole:'门店'
                    },
                    {
                        imgUrl:imgUrl,
                        fanName:'金迪莱高级定制',
                        fanRole:'木工'
                    },
                    {
                        imgUrl:imgUrl,
                        fanName:'上山去采药',
                        fanRole:'材料厂'
                    },
                    {
                        imgUrl:imgUrl,
                        fanName:'用户185*0605',
                        fanRole:'材料厂'
                    },
                ]
            },
            houseList:[
                {
                    layoutImg:img1,
                    entityImg:img2,
                    title:'雪溪苑豪装三房，装修40万左右，户型通透，有产证，房东诚售',
                    houseInfo:'3室2厅2卫 125.22㎡ 南北 中楼层/15层 精装 2015年建',
                    address:'太湖新城·雪溪苑A区',
                    attentionNum:435,
                    releaseTime:'2020-4-23'
                },
                {
                    layoutImg:img1,
                    entityImg:img2,
                    title:'雪溪苑豪装三房，装修40万左右，户型通透，有产证，房东诚售',
                    houseInfo:'3室2厅2卫 125.22㎡ 南北 中楼层/15层 精装 2015年建',
                    address:'太湖新城·雪溪苑A区',
                    attentionNum:435,
                    releaseTime:'2020-4-23'
                },
                {
                    layoutImg:img1,
                    entityImg:img2,
                    title:'雪溪苑豪装三房，装修40万左右，户型通透，有产证，房东诚售',
                    houseInfo:'3室2厅2卫 125.22㎡ 南北 中楼层/15层 精装 2015年建',
                    address:'太湖新城·雪溪苑A区',
                    attentionNum:435,
                    releaseTime:'2020-4-23'
                },
            ]
            
        }
    },
    computed: {
        
    },
    mounted: async function(){
        // 使用nowId请求数据
    },
    methods: {
        // 点击面包屑回到上一级
        goBack(){
            this.$emit('checkViewShow')
        },
        toContract(){
            this.$message('功能开发中')
        },
        toComplaint(){
            this.$message('功能开发中')
        },
        toFollow(){
            this.$message('功能开发中')
        },
        toSeeFan(){
            this.$message('功能开发中')
        },
        toLookHouse(){
            this.$message('功能开发中')
        }

    }
}
</script>
